<div class="page gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <span> <mat-icon (click)="goBack()">arrow_back</mat-icon></span>

    <span class="title">Preferences</span>
  </div>
  <div class="preference-content">
    <p class="description">Set your preferences to get loads that suit your needs.</p>
    <form [formGroup]="form">
      <mat-tab-group
        animationDuration="0ms"
        mat-align-tabs="center"
        mat-stretch-tabs="true"
        class="tab-list margin-bottom-lg"
        (selectedTabChange)="tabChanged($event)"
        [selectedIndex]="currentTab"
      >
        <!-- LOAD & EARNING -->
        <mat-tab label="LOAD & EARNING">
          <div class="margin-top-lg">
            <mat-form-field appearance="outline">
              <mat-label>Load Weight Preference</mat-label>
              <input
                matInput
                formControlName="loadWeightPreference"
                [value]="getFieldDisplayName('loadWeightPreference', 'loadWeightPreferenceOptions')"
                readonly
                (click)="
                  onOpenStatusActionSheet(loadWeightPreferenceOptions, 'Load Weight Preference', 'loadWeightPreference')
                "
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Max Deadhead Miles</mat-label>
              <input
                matInput
                formControlName="maxDeadheadMiles"
                [value]="getFieldDisplayName('maxDeadheadMiles', 'maxDeadheadMilesOptions')"
                readonly
                (click)="onOpenStatusActionSheet(maxDeadheadMilesOptions, 'Max Deadhead Miles', 'maxDeadheadMiles')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div class="margin-top-sm margin-bottom-sm">
            <mat-form-field appearance="outline">
              <mat-label>Favourite Lane Origin</mat-label>
              <input
                matInput
                #favouriteLaneOriginText
                formControlName="favouriteLaneOrigin"
                [value]="favouriteLaneOrigin"
                data-test="favouriteLaneOrigin-form-field"
                name="favouriteLaneOrigin"
                (input)="onInputChange('origin')"
                (focusout)="focusOut('origin')"
                (focus)="focusin()"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Favourite Lane Destination</mat-label>
              <input
                matInput
                #favouriteLaneDestinationText
                formControlName="favouriteLaneDestination"
                [value]="favouriteLaneDestination"
                data-test="favouriteLaneDestination-form-field"
                name="favouriteLaneDestination"
                (input)="onInputChange('destination')"
                (focusout)="focusOut('destination')"
                (focus)="focusin()"
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Earning Type</mat-label>
              <input
                matInput
                formControlName="earningType"
                [value]="getFieldDisplayName('earningType', 'earningTypeOptions')"
                readonly
                (click)="onOpenStatusActionSheet(earningTypeOptions, 'Earning Type', 'earningType')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>
        </mat-tab>

        <!-- LOCATION & VEHICLE -->
        <mat-tab label="LOCATION & VEHICLE">
          <div class="margin-top-lg">
            <mat-form-field appearance="outline">
              <mat-label>Truck Type</mat-label>
              <input
                matInput
                formControlName="truckType"
                [value]="getFieldDisplayName('truckType', 'truckTypeOptions')"
                readonly
                (click)="onOpenStatusActionSheet(truckTypeOptions, 'Truck Types', 'truckType')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Trailer Type</mat-label>
              <input
                matInput
                formControlName="trailerType"
                [value]="getFieldDisplayName('trailerType', 'trailerTypeOptions')"
                readonly
                (click)="onOpenStatusActionSheet(trailerTypeOptions, 'Trailer Type', 'trailerType')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Enter Base Location</mat-label>
              <input
                matInput
                #baseLocationText
                formControlName="baseLocation"
                [value]="baseLocation"
                data-test="baseLocation-form-field"
                name="baseLocation"
                (input)="onInputChange('base')"
                (focusout)="focusOut('base')"
                (focus)="focusin()"
              />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Time away from the Base</mat-label>
              <input
                matInput
                formControlName="daysAwayFromBaseLocation"
                [value]="getFieldDisplayName('daysAwayFromBaseLocation', 'daysAwayFromBaseLocationOptions')"
                readonly
                (click)="
                  onOpenStatusActionSheet(
                    daysAwayFromBaseLocationOptions,
                    'Time away from the Base',
                    'daysAwayFromBaseLocation'
                  )
                "
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Cross - border</mat-label>
              <input
                matInput
                formControlName="crossBorder"
                [value]="getFieldDisplayName('crossBorder', 'crossBorderOptions')"
                readonly
                (click)="onOpenStatusActionSheet(crossBorderOptions, 'Cross Border', 'crossBorder')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>

          <div [hidden]="!crossBorder.value">
            <mat-form-field appearance="outline">
              <mat-label>US Zone</mat-label>
              <input
                matInput
                formControlName="usZone"
                [value]="getFieldDisplayName('usZone', 'usZoneOptions')"
                readonly
                (click)="onOpenStatusActionSheet(usZoneOptions, 'US Zone', 'usZone')"
              />
              <span matSuffix><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
            </mat-form-field>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>
</div>
